import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Tooltip, { TooltipProps } from 'src/components/Tooltip';

const SizeEnum = {
  xs: 0.5,
  sm: 0.75,
  md: 1,
  lg: 1.25,
  '1x': 0.5,
  '2x': 0.75,
  '3x': 1,
  '4x': 1.25,
  '5x': 1.5,
  '6x': 1.75,
  '7x': 2,
  '8x': 2.25,
  '9x': 2.5,
  '10x': 2.75,
};

type IconProps = {
  icon: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: (e?: React.MouseEvent<HTMLSpanElement>) => void;
  size?: Size;
  showLoader?: boolean;
  tooltip?: TooltipProps;
  id?: string;
  disabled?: boolean;
};

const Icon: React.FunctionComponent<IconProps> = ({
  icon,
  className,
  onClick,
  style,
  size,
  showLoader,
  tooltip,
  id,
  disabled,
}) => {
  const [loading, setLoading] = useState(false);

  return showLoader && loading ? (
    <Spinner
      animation="border"
      className={className}
      style={{
        width: `${SizeEnum[size]}rem`,
        height: `${SizeEnum[size]}rem`,
        borderWidth: `${SizeEnum[size] * 0.15}rem`,
      }}
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
      }}
    />
  ) : tooltip ? (
    <Tooltip {...tooltip}>
      <i
        className={`icon-${icon} ${disabled ? 'bd-disable' : ''} ${className}`}
        onClick={async (e: React.MouseEvent<HTMLElement>) => {
          setLoading(true);
          await onClick(e);
          setLoading(false);
        }}
        style={{ fontSize: `${SizeEnum[size] * 0.9}rem`, ...style }}
      />
    </Tooltip>
  ) : (
    <i
      id={id}
      className={`icon-${icon} ${disabled ? 'bd-disable' : ''} ${className}`}
      onClick={async (e: React.MouseEvent<HTMLElement>) => {
        setLoading(true);
        await onClick(e);
        setLoading(false);
      }}
      style={{ fontSize: `${SizeEnum[size] * 0.9}rem`, ...style }}
    />
  );
};

Icon.defaultProps = {
  onClick: () => null,
  size: 'md',
  showLoader: false,
  id: '',
};

export default Icon;

// tslint:disable-next-line: prettier
type Size = keyof typeof SizeEnum;
